<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cvzsSH/tc-custom/9780310830269.jpg?1709150517441" alt="This image is the cover for the book Emerald Windows"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emerald Windows
      </h1>
      <p class="bookDescription body article font2">
        <p>Ten years ago, devastated by an ugly scandal, Brooke Martin fled the small town of Hayden to pursue a career as a stained glass artist. Now Brooke has returned on business to discover that some things never change. Her spotted reputation remains. Tongues still wag. And that makes what should be her dream assignment tough.Brooke has been hired to design new stained glass windows at Hayden Bible Church. The job is a career windfall. But Nick Marcello is overseeing the project, and some in the church think Nick and Brooke’s relationship is not entirely professional--and as before, there is no convincing those people otherwise. In the face of mounting rumors, the two set out to produce the masterpiece Nick has conceived: a brilliant set of windows displaying God’s covenants in the Bible. For Brooke, it is more than a project--it is a journey toward faith. But opposition is heating up. A vicious battle of words and will is about to tax Brooke’s commitment to the limit. Only this time, she is determined not to run.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terri Blackstock
      </h2>
      
      <p class="authorDescription body article"><P>Terri Blackstock has sold over seven million books worldwide and is a <I>New York Times</I> and <I>USA TODAY</I> bestselling author. She is the award-winning author of <I>Intervention</I>, <I>Vicious Cycle</I>, and <I>Downfall</I>, as well as such series as Cape Refuge, Newpointe 911, the SunCoast Chronicles, and the Restoration Series. Visit her website at www.terriblackstock.com; Facebook: tblackstock; Twitter: @terriblackstock.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?afc9a64c